<script>
  import axios from 'axios';
  import {mapGetters} from 'vuex';
  import {mapActions} from 'vuex';

  export default {
    name: "",
    props: {
      agreement: {
        type: String,
        default: '',
      },
      value: {
        type: Boolean,
        default: false,
      },
      form: {
        type: Object
      }
    },
    data() {
      return {
        cashes: [],
        isFeatureBlocked: false
      }
    },
    methods: {
      ...mapActions('user', {
        promptNoFeature: 'promptNoFeature',
      }),
      async init() {
        if (!this.hasFeature([8])){
          console.log('online cashboxes disabled');
          this.isFeatureBlocked = true;
          return;
        }
        this.cashes = await this.getList();
        if (this.cashes.length) {
          this.form.OnlineCashId = this.cashes[0].value
        }
      },
      getList() {
        return new Promise((resolve, reject) => {
          if (!this.agreement) {
            return resolve([]);
          }
          axios
            .get(
              `/tourclient/settings/onlineCashSettingsList?AgreementCode=${encodeURIComponent(this.agreement)}`,
            )
            .then(({data}) => {
              resolve(data.OnlineCashes ? data.OnlineCashes.map(i => ({
                ...i,
                value: i.Id,
                label: `${i.Name} ${i.LegalEntityId ? ('(' + i.LegalEntityName + ')') : ''}`,
              })) : []);
            })
            .catch(() => {
              resolve([]);
            })
        });
      },
      handleClick(){
        if (this.isFeatureBlocked){
          this.promptNoFeature('Работа с онлайн кассами недоступна для Вашего тарифного плана. Перейти к управлению тарифами?');
        }
      }
    },
    computed: {
      ...mapGetters({
        permission: 'permission',
      }),
      ...mapGetters('user', {
        hasFeature: 'hasFeature',
      }),
    },
    watch: {
      agreement(){
        this.init();
      }
    },
    components: {},
    mounted() {
      this.init();
    },
    destroyed() {
    },
  }
</script>
<template>
  <div v-if="form&&permission(283)" class="online-cashes-check">
    <div class="online-cashes-check__check">
      <div style="width: fit-content;" @click="handleClick">
        <el-checkbox
          :value="value"
          @input="$emit('input', $event)"
          :disabled="isFeatureBlocked || !cashes.length"
        >
          печатать чек
        </el-checkbox>
      </div>
    </div>
    <OnlineCashesForm
      :cashes="cashes"
      :form="form"
      v-if="value"
    >
    </OnlineCashesForm>
  </div>
</template>
<style lang="scss">
  .online-cashes-check {
    &__check {
      padding: 8px;
    }

    .online-cashes-form {
      display: flex;

      .el-form-item {
        width: 50%;
        padding: 0 8px;
      }

      .el-form-item__label {
        line-height: 20px;
      }
    }
  }
</style>
